const setQuote = (quote) => {
    return {
        type: 'CHANGE_QUOTE',
        data: quote
    }
}

module.exports = {
    setQuote
}